import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { isBefore } from 'date-fns'
import { useFormikContext } from 'formik'

import { NOTIFICATION_TYPE } from '../../../../../constants/common'
import { useUkTimeZone } from '../../../../../hooks'
import { formatDateToApi } from '../../../../../utils/date'
import {
  NEWSBOARD_POST_FORM_FIELD_NAME_END_DATE,
  NEWSBOARD_POST_FORM_FIELD_NAME_START_DATE,
} from '../../NewsboardPostForm.constants'

import { NOTIFICATION_INCORRECT_DATE_FIELD } from './useDateValidation.constants'

export function useDateValidation({ removeNotification, setNotification }) {
  const { setFieldError, values } = useFormikContext()

  const { timezone } = useUkTimeZone()
  const { t } = useTranslation()

  const startDate = formatDateToApi(
    values[NEWSBOARD_POST_FORM_FIELD_NAME_START_DATE],
    timezone
  )

  const endDate = formatDateToApi(
    values[NEWSBOARD_POST_FORM_FIELD_NAME_END_DATE],
    timezone
  )

  const dateEndBeforeDateStart =
    startDate != null && endDate != null && isBefore(endDate, startDate)

  useEffect(() => {
    if (!dateEndBeforeDateStart) {
      removeNotification(NOTIFICATION_INCORRECT_DATE_FIELD)
      setFieldError(NEWSBOARD_POST_FORM_FIELD_NAME_END_DATE, false)
    }
  }, [dateEndBeforeDateStart])

  function handleValidateDate() {
    if (dateEndBeforeDateStart) {
      setNotification?.({
        id: NOTIFICATION_INCORRECT_DATE_FIELD,
        text: t('Error.DateIncorrectFieldErrorKey'),
        type: NOTIFICATION_TYPE.error,
      })
      setFieldError(NEWSBOARD_POST_FORM_FIELD_NAME_END_DATE, true)
    }
  }

  return { dateEndBeforeDateStart, handleValidateDate }
}
